import {
  JobModel,
  useGetJobPoolQuery,
} from '@energy-stacks/fleet/feature-jobs-data';
import { useAppSelector } from '@energy-stacks/fleet/store';
import { toPayloadDate } from '@energy-stacks/shared';
import { useEffect, useRef, useState } from 'react';
import hash from 'object-hash';

type Params = {
  jobIds: JobModel['jobId'][];
  startDate: string | undefined;
  endDate: string | undefined;
};

export const useJobsPool = (
  { jobIds, startDate, endDate }: Params,
  { skip = false }
) => {
  const [jobPool, setJobPool] = useState<JobModel[]>();
  const lastSyncDataRef = useRef<string | null>(null);
  const selectedPlantId = useAppSelector(
    (state) => state.plant.selectedPlantId
  );

  const { data, isError, isLoading, refetch, isFetching, isSuccess } =
    useGetJobPoolQuery(
      {
        jobUids: jobIds,
        depotId: selectedPlantId || '',
        status: 'TO_DO',
        endDate: toPayloadDate(
          endDate ? new Date(endDate) : new Date(),
          'yyyy-MM-dd'
        ),
        startDate: toPayloadDate(
          startDate ? new Date(startDate) : new Date(),
          'yyyy-MM-dd'
        ),
      },
      { skip }
    );

  useEffect(() => {
    if (isSuccess && data !== undefined) {
      const newHash = hash(data);

      if (newHash !== lastSyncDataRef.current) {
        setJobPool(data);
        lastSyncDataRef.current = newHash;
      }
    }
  }, [data, isFetching, isSuccess]);

  useEffect(() => {
    if (isError) {
      setJobPool(undefined);
    }
  }, [isError]);

  return {
    jobPool,
    setJobPool,
    isLoadingJobPool: isLoading,
    isGetJobPoolError: isError,
    refetch,
  };
};
